import React from 'react'
import Contact from '../components/Contact'
import FullScreenImage from '../components/FullScreenImage'

function ContactPage() {
  return (
    <div>
        <FullScreenImage
        imageSrc="./assets/cp11.jpg"
        text=""
        />
        <Contact/>
    </div>
  )
}

export default ContactPage